<template>
  <div class="flex flex-wrap items-center justify-start" :class="gapClass">
    <img v-for="(badge, index) in badges" :key="index" :src="badge.img" :alt="badge.alt"
         :class="iconClass"
         class="z-0 cursor-pointer transition-all hover:scale-[2] hover:z-[1] hover:bg-gradientExtraFaint hover:rounded-md hover:shadow-md"/>
    <p v-if="badges.length === 0" class="-mt-4 mb-4 text-sm font-normal text-slate-400">No badges yet</p>
  </div>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  candidate: {
    type: Object,
    required: true
  },
  iconClass: {
    type: String,
    default: "h-16 w-16"
  },
  gapClass: {
    type: String,
    default: "gap-6"
  }
});

const badges = computed(() => {
  const candidate = props.candidate;

  return [
    candidate.hasInterviews ? {img: "https://resources.businessdraft.com/badges/BD_Digital_Badge_1st-Interview.png", alt: "1st Interview Badge"} : null,
    candidate.hasApplications ? {img: "https://resources.businessdraft.com/badges/BD_Digital_Badge_1st-Job-Application.png", alt: "1st Job Application Badge"} : null,
    candidate.studentAthlete ? {img: "https://resources.businessdraft.com/badges/BD_Digital_Badge_College-Athlete.png", alt: "College Athlete Badge"} : null,
    candidate.honorsStudent ? {img: "https://resources.businessdraft.com/badges/BD_Digital_Badge_College-Honors.png", alt: "College Honors Badge"} : null,
    candidate.military ? {img: "https://resources.businessdraft.com/badges/BD_Digital_Badge_Military-Service.png", alt: "Military Service Badge"} : null,
    (candidate?.profileVideo1?.path || candidate?.profileVideo2?.path) ? {img: "https://resources.businessdraft.com/badges/BD_Digital_Badge_Posted-A-Video.png", alt: "Posted a Video Badge"} : null,
    education.value.includes("Associate's Degree") ? {img: "https://resources.businessdraft.com/badges/BD_Digital_Badge_Associate-Degree.png", alt: "Associate's Degree Badge"} : null,
    education.value.includes("Bachelor's Degree")  ? {img: "https://resources.businessdraft.com/badges/BD_Digital_Badge_Bachelor-Degree.png", alt: "Bachelors Degree Badge"} : null,
    education.value.includes("Master's Degree") ? {img: "https://resources.businessdraft.com/badges/BD_Digital_Badge_Master-Degree.png", alt: "Masters Degree Badge"} : null,
    education.value.includes("Doctorate's Degree") ? {img: "https://resources.businessdraft.com/badges/BD_Digital_Badge_Doctorate-Degree.png", alt: "Doctorate Degree Badge"} : null,
  ].filter(Boolean);
});

const education = computed(() => {
  const completedEducationTypes = [];
  const candidateEdu = props.candidate.education || [];

  candidateEdu.forEach(item => {
    if(item?.completion === "Graduated") completedEducationTypes.push(item.type);
  });

  return completedEducationTypes;
});
</script>
